<template>
  <div class="group-wrap">
    <div class="content">
      <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
      <div class="search-box box">
        <time-search
          ref="timeSearch"
          :control="{ data: timeData }"
          @timeControlChange="timeControlChange"
          @timeControlClick="TimeControlClick"
        ></time-search>
      </div>
      <div v-loading="loading">
        <div class="chart-content">
          <el-row :gutter="14">
            <el-col :span="24">
              <div class="chart-box">
                <div class="title">综合能源趋势图</div>
                <div class="chart" id="lineChart"></div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="chart-box table-content">
          <div
            class="same-item"
            v-for="(item, index) in sameData"
            :key="index"
          >
            <same
              :obj="item"
              :unit="unit"
              type="hq"
              :sameTitle="sameTitle"
            ></same>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabTree from "@/components/common/TabTree.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import api from "@common/api/index.js";
import { findDataByParam } from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import NkTable from "@/components/common/NkTable.vue";
import echarts from "echarts";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import Same from "./page/same.vue";
import dateTool from "@/utils/dateTool.js";
import dayjs from 'dayjs'
let eleTimeData = [
  {
    type: "day",
    label: "日"
  },
  {
    type: "month",
    label: "月"
  },
  {
    type: "year",
    label: "年"
  }
];
export default {
  components: { TabTree, BtnShow, TimeSearch, NkTable, Same, ResizeContainer },
  data() {
    return {
      unit: "",
      tabShow: true,
      viewData: [],
      viewNodeData: [],
      timeData: eleTimeData,
      selectedMeasure: {
        id: "",
        measureName: ""
      },
      selectedDate: {
        startTime: "",
        endTime: ""
      },
      columns: [
        { prop: "name", label: "名称", show: true },
        { prop: "Ele", label: "电（kgce）", show: true },
        { prop: "DieselOil", label: "柴油（kgce）", show: true },
        { prop: "Water", label: "水（kgce）", show: true },
        { prop: "NaturalGas", label: "天然气（kgce）", show: true }
      ],
      TypeOfElectricityConsumption: [
        { name: "Ele", label: "电" },
        { name: "DieselOil", label: "柴油" },
        { name: "Water", label: "水" },
        { name: "NaturalGas", label: "天然气" }
      ],
      lineCharts: null,
      pieCharts: null,
      tableData: [],
      sameData: [],
      sameTitle: {
        current: { thisYear: "当年", today: "当天", thisMonth: "当月" },
        prev: { thisYear: "去年", today: "昨天", thisMonth: "上月" }
      },
      loading: true
    };
  },
  created() {},
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {
    let vm = this;
    vm.drawLine();
    vm.changeCompany()
  },
  methods: {
    changeCompany() {
      let vm = this;
      api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(this.$store.state.user.companyId, "/class/energyRing", null)
        .then(res => {
          const viewData = findDataByParam('energyMeasures', true, res.data)
          const unit = findDataByParam("unit", false, res.data);
          vm.unit = unit;
          this.viewData = viewData
          vm.getData()
        });
    },
    timeControlChange(e) {
      this.selectedDate = e;
    },
    TimeControlClick(e) {
      let vm = this;
      vm.selectedDate = e;
      vm.getData();
    },
    getTreeData(data) {
      let vm = this;
      vm.viewNodeData = data;
    },
    tabTreeDefault(e) {
      let vm = this;
      vm.selectedMeasure = e;
      vm.getData();
    },
    tabTreeClick(e) {
      let vm = this;
      vm.selectedMeasure = e;
      vm.getData();
    },
    async getData() {
      let vm = this
      vm.columns = [];
      vm.loading = true
      const measures = this.viewData.map((k) => {
        vm.columns.push({
          prop: k.key,
          label: k.label,
        })
        return {
          measureId: k.measureId,
          pointCode: k.pointCode,
          pointNumber: k.pointNumber
        }
      })

      let expressionName = "ENERGY_CONSUMPTION";
      let startTime = vm.selectedDate.startTime;
      let endTime = vm.selectedDate.endTime;
      let dateType = vm.selectedDate.dateType;

      //同期时间
      let startTimeSame = null;
      let endTimeSame = null;
      let xData = [];
      let xDataSame = [];
      let apiName = "";
      let apiName2 = "";
      if (dateType == "day") {
        startTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setDate(new Date(startTime).getDate() - 1)
          ),
          "yyyy-MM-dd hh:mm:ss"
        );
        endTimeSame = startTime;
        xData = handleData.createXData("0", startTime, endTime, false);
        xDataSame = handleData.createXData(
          "0",
          startTimeSame,
          endTimeSame,
          false
        );
        apiName = "getQuantityHour2";
        apiName2 = "getQuantityHour2";
      } else if (dateType == "month") {
        startTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setMonth(new Date(startTime).getMonth() - 1)
          ),
          "yyyy-MM-dd hh:mm:ss"
        );
        endTimeSame = startTime;
        xData = handleData.createXData("2", startTime, endTime, false);
        xDataSame = handleData.createXData(
          "2",
          startTimeSame,
          endTimeSame,
          false
        );
        apiName = "getQuantityDay3";
        apiName2 = "getQuantityDay3";
      } else {
        startTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setFullYear(
              new Date(startTime).getFullYear() - 1
            )
          ),
          "yyyy-MM-dd hh:mm:ss"
        );
        endTimeSame = startTime;
        xData = handleData.createXData("5", startTime, endTime, false);
        xDataSame = handleData.createXData(
          "5",
          startTimeSame,
          endTimeSame,
          false
        );
        apiName = "getQuantityMonth2";
        apiName2 = "getQuantityMonth2";
      }
      Promise.all([
        api.quantity[apiName](
          measures,
          startTime,
          endTime
        ),
        api.quantity[apiName2](
          measures,
          startTimeSame,
          endTimeSame
        ),
      ]).then(async resArr => {
        // 曲线图
        let apiData = resArr[0].data;
        let lineItem = apiData
        let apiData2 = resArr[1].data;
        let lineItemSame = apiData2
        if (apiName === 'getQuantityDay3') {
          apiData.forEach(it => {
            it.data = it.data[0]
          })
          apiData2.forEach(it => {
            it.data = it.data[0]
          })
        }
        let line = {
          xAxis: {
            type: "category",
            data: []
          },
          series: []
        };
        let legendData = [];
        for (let i = 0; i < this.viewData.length; i++) {
          let seriesItem = {
            data: [],
            type: "bar",
            barGap: 0,
            name: this.viewData[i].label,
            stack: "总量"
          };
          let seriesItem2 = {
            data: [],
            type: "bar",
            name: this.viewData[i].label + "环期",
            stack: "环期总量"
          };
          legendData.push(this.viewData[i].label);
          legendData.push(this.viewData[i].label + "环期");
          for (let j = 0; j < xData.length; j++) {
            if (i == 0) {
              line.xAxis.data.push(xData[j].title);
            }
            const dataItem = lineItem[i].data.find(
              c => new Date(c.time).getTime() == xData[j].value
            );

            if (dataItem) {
              let val =
                typeof dataItem.value == "number"
                  ? dataItem.value.toFixed(2)
                  : "-";
              seriesItem.data.push(val);
            } else {
              seriesItem.data.push("");
            }
            if (xDataSame.length > j) {
              const dataItem2 = lineItemSame[i].data.find(
                c => new Date(c.time).getTime() == xDataSame[j].value
              );
              if (dataItem2) {
                let val =
                  typeof dataItem2.value == "number"
                    ? dataItem2.value.toFixed(2)
                    : "-";
                seriesItem2.data.push(val);
              } else {
                seriesItem2.data.push("");
              }
            } else {
              seriesItem2.data.push("");
            }
          }
          line.series.push(seriesItem);
          line.series.push(seriesItem2);
        }
        let option = vm.lineCharts.getOption();
        option.legend = {
          type: "scroll",
          top: 0,
          left: 80,
          data: (function () {
            return legendData;
          })()
        };
        option.xAxis = line.xAxis;
        option.series = line.series;
        option.yAxis[0].name = vm.unit;
        vm.lineCharts.setOption(option, true);
        await this.getSameData(measures, lineItem, lineItemSame)
        vm.loading = false;
      });
    },
    async getSameData(measures, lineItem, lineItemSame) {
      const vm = this;
      const startTime = vm.selectedDate.startTime
      let sameData = this.viewData.map(k => ({
        currentDayValue : "-", currentMonthValue : "-", currentYearValue : "-", dayRatio : "-", lastDayValue : "-", lastMonthValue : "-", lastYearValue : "-",className: k.label, measureId : k.measureId, monthRatio : "-", yearRatio : "-", }));
      const dayStartTimeSame = dateTool.format(
        new Date(
          new Date(startTime).setDate(new Date(startTime).getDate() - 1)
        ),
        "yyyy-MM-dd hh:mm:ss"
      );
      const monthStartTimeSame = dateTool.format(
        new Date(
          new Date(startTime).setMonth(new Date(startTime).getMonth() - 2)
        ),
        "yyyy-MM-dd hh:mm:ss"
      );
      const yearStartTimeSame = dateTool.format(
        new Date(
          new Date(startTime).setFullYear(
            new Date(startTime).getFullYear() - 2
          )
        ),
        "yyyy-MM-dd hh:mm:ss"
      );

      const [dayRes, monthRes, yearRes] = await Promise.all([
        api.quantity.getQuantityDay3(measures, dayStartTimeSame, startTime),
        api.quantity.getQuantityMonth2(measures, monthStartTimeSame, startTime),
        api.quantity.getQuantityYear2(measures, yearStartTimeSame, startTime)
      ])
      dayRes.data.forEach((it, index) => {
        it.data.forEach((k, i) => {
          sameData[index]['lastDayValue'] = k[0]?.value || '-'
          sameData[index]['currentDayValue'] = k[1]?.value || '-'
          if (sameData[index]['currentDayValue'] === '-') {
              sameData[index]['dayRatio'] = '-'
          } else {
            sameData[index]['dayRatio'] = ((sameData[index]['currentDayValue'] - sameData[index]['lastDayValue']) / sameData[index]['lastDayValue'] * 100).toFixed(2) || 0
          }
        })
      })
      monthRes.data.forEach((it, index) => {
        it.data.forEach((k, i) => {
          if (!i) {
            sameData[index]['lastMonthValue'] = k.value || '-'
          } else {
            sameData[index]['currentMonthValue'] = k.value || '-'
          }
        })
        if (sameData[index]['currentMonthValue'] === '-') {
            sameData[index]['monthRatio'] = '-'
        } else {
          sameData[index]['monthRatio'] = ((sameData[index]['currentMonthValue'] - sameData[index]['lastMonthValue']) / sameData[index]['lastMonthValue'] * 100).toFixed(2) || 0
        }
      })
      yearRes.data.forEach((it, index) => {
        it.data.forEach((k, i) => {
          if (!i) {
            sameData[index]['lastYearValue'] = k.value || '-'
          }  else {
            sameData[index]['currentYearValue'] = k.value || '-'
          }
        })
        if (sameData[index]['currentYearValue'] === '-') {
            sameData[index]['yearRatio'] = '-'
        } else {
          sameData[index]['yearRatio'] = ((sameData[index]['currentYearValue'] - sameData[index]['lastYearValue']) / sameData[index]['lastYearValue'] * 100).toFixed(2) || 0
        }
      })

      console.error(sameData);
      vm.sameData = sameData;
    },
    drawLine() {
      let vm = this;
      this.lineCharts = echarts.init(document.getElementById("lineChart"));
      let option = {
        // legend: {
        //   type: "scroll",
        //   textStyle: {
        //     color: "#bcbdbe",
        //   },
        //   left: 10,
        //   right: 10,
        //   height: "30px",
        // },
        tooltip: {
          trigger: "axis",
          confine: true,
          textStyle: {
            align: "left"
          }
        },
        xAxis: {
          type: "time",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#bcbdbe",
              width: 2
            }
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#bcbdbe"
            }
          }
        },
        grid: {
          x: 66,
          y: 30,
          x2: 20,
          y2: 30
        },
        yAxis: [
          {
            type: "value",
            name: vm.unit
          }
        ],
        label: {},
        color: [
          "#d68818",
          "#88a80a",
          "#308145",
          "#318e96",
          "#326293",
          "#3d66c1",
          "#3a32ab",
          "#6325aa",
          "#9a1eac",
          "#b92626"
        ],
        series: []
      };
      this.lineCharts.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
.group-wrap {
  padding: 14px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
}
.tree-content {
  //   width: 260px;
  min-width: 200px;
  margin-right: 14px;
}
.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  background: transparent;
}
.search-box {
  height: 40px;
}
.chart-content {
  margin-top: 14px;
  width: 100%;
}
.chart-box {
  width: 100%;
  height: 400px;
  border-radius: 4px;
  background: #ffffff;
  flex-flow: column;
  .title {
    height: 30px;
    line-height: 30px;
    padding: 0px 10px;
    color: #000;
    text-align: left;
    font-weight: bold;
  }
  .chart {
    width: 100%;
    height: calc(100% - 30px);
    padding: 10px;
    box-sizing: border-box;
  }
}

.table-content {
  margin-top: 14px;
  height: 320px;

  overflow: auto;
}
.same-item {
  padding: 10px;
  padding-bottom: 0px;
}
.same-item:last-child {
  padding-bottom: 10px;
}
</style>
